import React, { Component } from "react";
import {
    DKLabel,
    showToast,
    TOAST_TYPE,
    DKButton,
    DKIcons,
    DKInput,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";
import i18next from "i18next";
import Utility, { deepClone } from "../../../utility/Utility";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import FormatCurrencyService from "../../../services/FormatCurrencyService";

class InvoiceCommissionAction extends Component {
    currencyCode = TenantService.get(TENANT.CURRENCY_CODE);

    defaultFields = {
        invoiceField: {
            id: "invoiceField",
            placeholder: "Invoice Field",
            type: INPUT_TYPE.DROPDOWN,
            value: "Invoice Amount",
            options: [{ label: "Invoice Amount", value: "invoiceAmount"}],
            validation: [["required"]]
        },
        from: {
            id: "from",
            placeholder: "From",
            type: INPUT_TYPE.NUMBER,
            value: 1,
            validation: [["required"], ["GreaterThanEquals", 1000]]
        },
        to: {
            id: "to",
            placeholder: "To",
            type: INPUT_TYPE.NUMBER,
            value: 1000,
            validation: [["required"]]
        },
        commissionValue: {
            id: "commissionValue",
            placeholder: "Commission",
            type: INPUT_TYPE.NUMBER,
            value: 5,
            validation: [["required"], ["max", 100]]
        },
        commissionField: {
            id: "commissionField",
            placeholder: "Commission Type",
            type: INPUT_TYPE.DROPDOWN,
            value: "Percentage",
            options: [{ label: "Fixed Amount", value: "flatAmount" }, { label: "Percentage", value: "percentageOfDealCost" }],
            validation: [["required"]]
        }
    };

    logicalOperators = [{ label: "Or", value: "or" }];

    constructor(props) {
        super(props);
        this.state = {
            stepData: this.props.stepData,
            conditions: this.props.stepData?.configuration?.fields?.length > 0 ? [] : [deepClone(this.defaultFields)],
            logicalOperator: "or"
        }
    }

    componentDidMount() {
        if (this.props.stepData?.configuration) {
            this.setStepData(this.props.stepData);
        }
    }

    setStepData(stepData) {
        const fields = stepData?.configuration?.fields;
        const logicalOperator = stepData?.logicalOperator;

        if (fields?.length > 0) {
            const conditions = [];
            fields.forEach((field, index) => {
                const condition = deepClone(this.defaultFields);
                Object.entries(field).forEach(([key, value]) => {
                    switch (key) {
                        case "invoiceAmount":
                            condition.invoiceField.value = this.getDropdownLabel(key, condition.invoiceField.options);
                            if (Array.isArray(value)) {
                                condition.from.value = value[0];
                                condition.to.value = value[1];
                                condition.commissionValue.value = value[2];
                                condition.commissionField.value = this.getDropdownLabel(value[3], condition.commissionField.options);

                                this.updateValueAndValidity(condition, "to");
                                this.updateValueAndValidity(condition, "commissionField");

                                if (index !== fields.length - 1) {
                                    condition.from.readOnly = true;
                                    condition.to.readOnly = true;
                                }

                                if (index === fields.length - 1) {
                                    condition.from.readOnly = true;
                                }
                            }
                            break;
                        default:
                            break;
                    }
                });
                conditions.push(condition);
            });

            this.setState({
                conditions: conditions
            });
        }
    }

    getDropdownLabel(v, o) {
        let value = v;

        const index = o.findIndex(i => i.value === v);
        if (index !== -1) {
            value = o[index].label;
        }

        return value;
    }

    getDropdownValue(v, o) {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }

    addCondition() {
        const invalid = this.isInvalidCondition();
        if (invalid.isInvalid) {
            showToast(invalid.errorMessage, TOAST_TYPE.FAILURE);
            return;
        }

        const conditions = [...this.state.conditions];
        const newCondition = deepClone(this.defaultFields);
        const firstCondition = conditions.at(0);
        const prevCondition = conditions.at(-1);

        newCondition.from.value = parseFloat(prevCondition.to.value);
        newCondition.to.value = parseFloat(firstCondition.to.value) + parseFloat(prevCondition.to.value);
        newCondition.from.validation = [["required"], ["GreaterThanEquals", newCondition.to.value]];

        if (prevCondition.commissionField.value === "Percentage") {
            newCondition.commissionField.value = "Percentage";
            newCondition.commissionValue.value = parseFloat(prevCondition.commissionValue.value) + 5;
            if (newCondition.commissionValue.value > 100) {
                newCondition.commissionValue.value = 100;
            }
            newCondition.commissionValue.validation = [["required"], ["max", 100]];
        } else {
            newCondition.commissionField.value = "Fixed Amount";
            newCondition.commissionValue.value = parseFloat(prevCondition.commissionValue.value) * 2;
            newCondition.commissionValue.validation = [["required"]];
        }

        conditions.forEach((c) => {
            c.from.readOnly = true;
            c.to.readOnly = true;
        });

        newCondition.from.readOnly = true;

        this.setState({
            conditions: [...conditions, newCondition]
        });
    }

    deleteCondition(index) {
        if (index !== 0) {
            const conditions = this.state.conditions.filter((c, i) => i !== index);
            const lastCondition = conditions.at(-1);

            lastCondition.from.readOnly = false;
            lastCondition.to.readOnly = false;

            this.setState({
                conditions: conditions
            });
        }
    }    

    isRequired(validation) {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }
    
    isInvalidCondition() {
        const invalid = {
            isInvalid: false,
            errorMessage: ""
        }

        const condtions = [...this.state.conditions];
        condtions.forEach((condition) => {
            Object.entries(condition).forEach(([key, field]) => {
                const error = this.hasError(field, field.value);
                field.invalid = error.invalid;
                field.errorMessage = error.errorMessage;
    
                if (!invalid.isInvalid && field.invalid) {
                    invalid.isInvalid = field.invalid;

                    if (field.errorMessage === "<span></span>") {
                        invalid.errorMessage = "Please fill all the required fields";
                    } else {
                        invalid.errorMessage = field.errorMessage;
                    }
                }
            });
        });

        this.setState({
            conditions: condtions
        });

        return invalid;
    }

    hasError(field, value) {
        let error = {
            invalid: false,
            errorMessage: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                            error.errorMessage = "<span></span>";
                        }
                        break;
                    case "GreaterThanEquals":
                        if (!Utility.isEmpty(value) && !Utility.isEmpty(validation[1]) && value >= validation[1]) {
                            error.invalid = true;
                            error.errorMessage = `${field.placeholder} field cannot be greater than or equals To field`;
                        }
                        break;
                    case "max":
                        if (!Utility.isEmpty(value) && !Utility.isEmpty(validation[1]) && value > validation[1]) {
                            error.invalid = true;
                            error.errorMessage = `${field.placeholder} percent cannot be greater than 100%`;
                        }
                        break;
                    default:
                        error.invalid = false;
                        error.errorMessage = null;
                        break;
                }
            });
        }

        return error;
    }

    updateState(index, stateName, value) {
        const conditions = [...this.state.conditions];
        const field = conditions[index][stateName];
        conditions[index][stateName] = {...field, value: value, ...this.hasError(field, value)};

        this.updateValueAndValidity(conditions[index], stateName);

        this.setState({
            conditions: conditions
        });
    }

    updateValueAndValidity(condition, stateName) {
        switch (stateName) {
            case "to":
                condition.from.validation = [["required"], ["GreaterThanEquals", parseFloat(condition.to.value || 0)]];
                break;
            case "commissionField":
                if (condition.commissionField.value === "Percentage") {
                    condition.commissionValue.validation = [["required"], ["max", 100]];
                } else {
                    condition.commissionValue.validation = [["required"]];
                }
                break;
            default:
                break;
        }
    }

    save() {
        const invalid = this.isInvalidCondition();
        if (invalid.isInvalid) {
            showToast(invalid.errorMessage, TOAST_TYPE.FAILURE);
            return;
        }

        const fields = [];
        this.state.conditions.forEach((c) => {
            const invoiceField = this.getDropdownValue(c.invoiceField.value, c.invoiceField.options);
            const commissionField = this.getDropdownValue(c.commissionField.value, c.commissionField.options);
            const field = {
                [invoiceField]: [c.from.value, c.to.value, c.commissionValue.value, commissionField]
            }

            fields.push(field);
        });

        this.props.onSave(fields, this.state.logicalOperator);
    }

    renderField(index, field, width) {
        switch (field.type) {
            case INPUT_TYPE.NUMBER:
                return (
                    <div key={field.id} style={{ flex: "0 0 100%", maxWidth: width }}>
                        <div className="row mb-s position-relative p-h-xs">
                            <DKInput
                                title={field.title}
                                placeholder={field.placeholder}
                                type={field.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly}
                                required={this.isRequired(field.validation)}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "warning-tooltip-prop"
                                }}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                onChange={(value) => {
                                    this.updateState(index, field.id, value);
                                }}
                                validator={field.validator}
                            />
                        </div>
                    </div>
                );
            case INPUT_TYPE.DROPDOWN:
                return (
                    <div key={field.id} style={{ flex: "0 0 100%", maxWidth: width }}>
                        <div className="row mb-s position-relative p-h-xs">
                            <DKInput
                                title={field.title}
                                placeholder={field.placeholder}
                                type={INPUT_TYPE.DROPDOWN}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                dropdownConfig={{
                                    allowSearch: field.options?.length > 6,
                                    searchableKey: "label",
                                    data: field.options,
                                    renderer: (i, item) => item.label,
                                    onSelect: (i, value) => {
                                        this.updateState(index, field.id, value.label);
                                    },
                                }}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly}
                                required={this.isRequired(field.validation)}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                );
            default:
                break;
        }
    }

    renderHeader() {
        return (
            <div className="row justify-content-between pt-s pb-s bg-gray3 p-h-m">
                <DKLabel text={i18next.t("CALCULATE_COMMISSION")} className="fw-m" />
                <DKButton icon={DKIcons.ic_close} onClick={this.props.onClose} />
            </div>
        )
    }

    getConditionText(condition) {
        return (
            <div className="row pb-xl p-h-xl">
                If&nbsp;
                <DKLabel text={condition.invoiceField.value} className="fw-b" />
                &nbsp;is in between&nbsp;
                <DKLabel text={condition.from.value || "-"} className="fw-b" />
                &nbsp;and&nbsp;
                <DKLabel text={condition.to.value || "-"} className="fw-b" />
                &nbsp;then commission will be&nbsp;
                {condition.commissionField.value === "Percentage" && <DKLabel text={`${condition.commissionValue.value || 0}%`} className="fw-b" />}
                {condition.commissionField.value !== "Percentage" && <DKLabel text={FormatCurrencyService.format(condition.commissionValue.value)} className="fw-b" />}
            </div>
        )
    }

    renderConditions() {
        return (
            <>
                <div className="parent-width">
                    <div className="row p-h-l pb-l">
                        <div className="column align-items-center" style={{ flex: "0 0 100%", maxWidth: "53%" }}>
                            <DKLabel text={"Invoice Fields"} className="fw-b" />
                        </div>
                        <div className="column align-items-center" style={{ flex: "0 0 100%", maxWidth: "47%" }}>
                            <DKLabel text={"Commission Fields"} className="fw-b" />
                        </div>
                    </div>
                    {this.state.conditions.map((condition, index) => {
                        return (
                            <>
                                <div className="row p-h-l">
                                    {this.renderField(index, condition.invoiceField, "23%")}
                                    {this.renderField(index, condition.from, "15%")}
                                    {this.renderField(index, condition.to, "15%")}
                                    <DKLabel text={"="} className="fs-m p-h-xs" style={{ alignSelf: "start", marginTop: "10px" }} />
                                    {this.renderField(index, condition.commissionValue, "18%")}
                                    {this.renderField(index, condition.commissionField, "22%")}
                                    <DKButton
                                        disabled={index === 0 || index !== this.state.conditions.length - 1}
                                        icon={DKIcons.ic_delete}
                                        style={{ alignSelf: "start", marginTop: "2px", opacity: (index === 0 || index !== this.state.conditions.length - 1) ? 0.4 : 1 }}
                                        onClick={() => this.deleteCondition(index)}
                                    />
                                </div>
                                {this.getConditionText(condition)}
                            </>
                        )
                    })}
                    {this.state.conditions.length > 1 && <div className="column align-items-center cursor-hand">
                        <div className="border-m shadow-s-2 border-radius-s">
                            {this.logicalOperators.map((lo) => {
                                return (
                                    <div onClick={() => { this.setState({ logicalOperator: lo.value }) }}>
                                        <DKLabel text={lo.label} className={"p-v-xs p-h-s bg-gray1 fw-m"}/>
                                    </div>
                                )
                            })}
                        </div>
                    </div>}
                    <div className="row p-h-l">
                        <DKButton
                            title={"+ Add another condition"}
                            className="text-blue fw-m"
                            onClick={() => this.addCondition()}
                        />
                    </div>
                </div>
            </>
        )
    }

    renderFooter() {
        return (
            <div className="row-reverse p-h-l">
                <DKButton
                    title="Save"
                    className="bg-button text-white ml-m"
                    onClick={() => {
                        this.save();
                    }}
                />

                <DKButton
                    title="Cancel"
                    className="bg-gray1 border-m"
                    onClick={this.props.onClose}
                />
            </div>
        );
    }

    render() {
        return (
            <div className="transparent-background">
                <div className="popup-window" style={{ padding: 0, maxWidth: 650 }}>
                    {this.renderHeader()}
                    <div className="parent-width p-v-l">
                        {this.renderConditions()}
                        {this.renderFooter()}
                    </div>
                </div>
            </div>
        )
    }
}

export default InvoiceCommissionAction;
